import axios from "axios"

export default class PropertyDetailsService {
  static async getBasicValuationReport(valuationId) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/valuation/${valuationId}/basic`
    )
  }

  static async getValuationReport(authToken) {
    return axios.get(`${process.env.REACT_APP_API_BASE_URL}/valuation`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
  }

  static async getUserValuationReport(authToken) {
    return axios.get(`${process.env.REACT_APP_API_BASE_URL}/valuation/user`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
  }

  static async getValuationFiles(authToken, valuationId) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/valuation/${valuationId}/files`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  }

  static async getValuationWarnings(authToken, codes) {
    return axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/warning`,
      {
        codes,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  }

  // Aqui se obtienen las imagenes para el property-details 
  static async getValuationImages(authToken, valuationId) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/valuation/${valuationId}/stored-images`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  }

  static async getValuationPoi(authToken, poi) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/poi?latitude=${poi.lat}&longitude=${poi.long}&name=${poi.name}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  }

  static async updateValuationField(authToken, valuationId, data) {
    return axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/valuation/user/${valuationId}/field`,
      data,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        "Content-Type": "application/json",
      }
    )
  }

  static async reportAppError(data) {
    return axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/valuation/report-error`,
      {
        data,
      }
    )
  }
}
